/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RoleEnum {
    WITNESS = 'witness',
    VICTIM = 'victim',
    SUSPECT = 'suspect',
    IRRELEVANT = 'irrelevant',
}